import "./estimate-cost-row-popup.css";
import 'jquery.calculator/jquery.calculator.css';
import "jquery.calculator/jquery.plugin";
import "jquery.calculator";
import "jquery";
import "jqueryui";
import * as _ from "lodash";
import * as ko from "knockout";
import * as $ from "jquery";
import { EstimateRow } from "../../services/state/estimateRow";
import { CostbookRow } from "../../services/state/costbookRow";
import { CostbookRowType } from "../../services/state/costbookRowType";
import { CraftCode } from "../../services/api/costbooks-api";
import { CommandType } from "../../services/commandType";
import { PopupMode, PopupParamsWithPlayload } from "../../services/popups/popup";
import { dxKnockoutPopupOptions, Popup} from "../../services/common/popup-helper";
import { dxKnockoutNumberBoxOptions } from "../../services/common/common-types";

class CostRowEditorModel {
    id = ko.observable<number | undefined>();
    baseRowId = ko.observable<number | undefined>();
    title = ko.observable<string | undefined>();
    description = ko.observable<string | undefined>();
    pasteTitle = ko.observable<boolean>();
    quantity = ko.observable<number>(0);
    unitOfMeasure = ko.observable<string | undefined>();
    craftCode = ko.observable<string | undefined>();
    hourlyWage = ko.observable<number>(0);
    hourlyWageRaw = ko.observable<number>(0);
    manHours = ko.observable<number>(0);
    material = ko.observable<number>(0);
    labor = ko.observable<number>(0);
    equipment = ko.observable<number>(0);
    total = ko.observable<number>(0);

    laborPriceOverride = ko.observable<boolean>(false);
    crewDescription = ko.observable<string | undefined>();
}

class CostRowEditorTotals {

    notifyEnabled = true;

    dummy = ko.observable<Date>();

    private round(num: number, decimalPlaces: number = 2) : number {
        let val = Math.round(num * 1000) / 1000;
        return parseFloat(val.toFixed(decimalPlaces));
    }

    private roundToThreeSignificantDigits(num: number): number {
        let val = Math.round(num * 1000) / 1000;
        return parseFloat(parseFloat(val.toPrecision(3)).toFixed(2));
    }
    
    manHoursTotal = ko.computed<number>(() => {
        let dummy = this.dummy();
        return this.getSubtotal(this.model.manHours(), 3);
    });

    materialTotal = ko.computed<number>(() => {
        let dummy = this.dummy();
        return this.getSubtotal(this.model.material());
    });

    laborTotal = ko.computed<number>(() => {
        let dummy = this.dummy();
        return this.getSubtotal(this.model.labor(), 2, 4);
    });

    equipmentTotal = ko.computed<number>(() => {
        let dummy = this.dummy();
        return this.getSubtotal(this.model.equipment());
    });

    totalTotal = ko.computed<number>(() => {
        let dummy = this.dummy();
        return this.getSubtotal(this.model.total());
    });

    isTotalReadonly = ko.computed<boolean>(() => {
        if (!this.model)
            return true;

        if (this.model.manHours() > 0) 
            return true;

        if (this.model.labor() > 0)
            return true;

        if (this.model.material() > 0)
            return true;

        if (this.model.equipment() > 0)
            return true;

        return false;
    });
    


    constructor(public model: CostRowEditorModel) {
        
        this.dummy.subscribe(() => {
            if (this.isTotalReadonly()) {
                this.model.total(this.getTotal());
            }
        });

        this.model.quantity.subscribe(() => {
            this.dummy(new Date());
        });

        this.model.equipment.subscribe(() => {
            this.dummy(new Date());
        });

        this.model.material.subscribe(() => {
            this.dummy(new Date());
        });


        this.model.hourlyWage.subscribe((val) => {
            if (!val || !this.model.manHours()) {
                this.dummy(new Date());
                return;
            }
            let labor = this.roundToThreeSignificantDigits(this.model.hourlyWage() * this.model.manHours());
            this.model.labor(labor);
            this.dummy(new Date());
        });

        this.model.labor.subscribe((val) => {
            if (!this.notifyEnabled || !val || !this.model.hourlyWage()) {
                this.dummy(new Date());
                return;
            }
            let manHours = this.round(val / this.model.hourlyWage(), 3);
            this.model.manHours(manHours);
            this.dummy(new Date());
        });

        this.model.manHours.subscribe((val) => {
            if (!val || !this.model.hourlyWage()) {
                this.dummy(new Date());
                return;
            }
            //TNE-187 - we need to round to 4 significant digits
            let labor = this.roundToThreeSignificantDigits(this.model.hourlyWage() * this.model.manHours());
            this.model.labor(labor);
            this.dummy(new Date());
        });


        this.model.total.subscribe((val) => {
            if(isNaN(val))
                return;
        });
    }

    public getTotal() {
        if (this.isTotalReadonly()) {
            if (this.model.material() == 0 && this.model.labor() == 0 && this.model.equipment() == 0)
                return this.model.total();

            let result = 0;

            if (this.model.material())
                result += +this.model.material();

            if (this.model.labor())
                result += +this.model.labor();

            if (this.model.equipment())
                result += +this.model.equipment();
            
            return this.round(result);
        }
        
        return this.model.total();
    }

    private getSubtotal(val: any, decimalPlaces: number = 2, precision: number = 0) {
        if (!this.model)
            return 0;

        if (!this.model.quantity())
            return 0;

        if (!val)
            return 0;

        let rounded = this.model.quantity() * val;
        if (rounded > 0 && precision > 0)
            rounded = parseFloat(rounded.toPrecision(precision));
        rounded = this.round(rounded, decimalPlaces);
        
        return rounded;
    }
}

export enum EditorMode {
    Simple,
    Advanced
}

export type EstimateCostRowPopupParams = {
    popupMode: PopupMode;
    editorMode: EditorMode;
    insertAbove: boolean;
    insertToTheEnd?: boolean;
    title?: string;
    period?: string;
    price?: number;
    result?: any;
}

class EstimateCostRowPopupViewModel {
    mode = ko.observable<EditorMode>(EditorMode.Simple);
    model = new CostRowEditorModel();
    computed = new CostRowEditorTotals(this.model);
    focused: any;
    focusedObservable: KnockoutObservable<Number> | undefined;    
    calculatorOpened = ko.observable<boolean>(false);
    isSaving = false;    
    craftFirstTimeSelected = ko.observable<boolean>(true);    
    unitsOfMeasure = [ "CLF", "CSF", "CSY", "Ea", "LF", "m", "Mi", "Mile", "MLF", "MSF", "SF", "SQ", "SY", "VLF", "Yard" ];

    private popupInputs: any[] = [];
    popup: Popup = new Popup(<dxKnockoutPopupOptions>{
        title: "Cost Row Editor",
        contentTemplate: "template",
        wrapper: ".estimate-cost-row-popup",
        onEnterKeyDown: () => { 
            let self = this;
            if (!self.isSaving && !self.calculatorOpened())
                self.save();    
            },
        
        dragEnabled: true,
        resizeEnabled: true,
        minWidth: 640,
        width: 640,
        minHeight: 600,
        height: 600,
        shading: true,         
        visible: this.params.visible,        
        toolbarItems: [
            {
            widget: "dxButton",
            toolbar: "bottom",
            location: "before",
            options: {
                text: "Save",
                type: "default",
                onClick: () => {
                    let self = this;
                    if(!this.isSaving)
                        self.save();
                }
            }
            },
            {
                widget: "dxButton",
                toolbar: "bottom",
                location: "after",
                options: {
                    text: "Cancel",
                    type: "default",
                    onClick: () => {
                        let self = this;
                        self.close();
                    }
                }
            },
            {
                widget: "dxButton",
                toolbar: "bottom",
                location: "before",
                options: {
                    elementAttr: {
                        class: 'calculator-button'
                    },
                    text: "Calculator",
                    type: "default",
                    onClick: () => {
                        let self = this;
                        self.calculatorOpened(true);
                        $(self.focused).calculator('show');
                    },
                }
            }],
        
        onShown: (e) => {
            setTimeout(() => {
                let self = this;                
                let elements = self.popup.getElement()!.getElementsByTagName("input");
                this.popupInputs = _.filter(elements, (item) => { return item.className ;});
                if(this.popupInputs.length == 0)
                    return;
               
                $('.estimate-cost-row-popup').on('focus', '*', (e: any) => {
                    let validInput = $(e.target).hasClass('is-calculator');
                    if (validInput) {
                        //hide calc if we switch from one calc-enabled input to another
                        if (self.focused != e.target) {
                            $(self.focused).calculator('hide');
                        }
                        self.focused = e.target;
                    }
                });

                $('div.dx-numberbox input.dx-texteditor-input:not([readonly])').calculator({
                    showOn: 'operator',
                    isOperator: () => { return false; },
                    onButton: (label: any, value:any, inst:any) => {
                        if (label == "Use")
                            this.focusedObservable!(value);
                        if (label == "Close")
                            this.calculatorOpened(false);
                    },
                    constrainInput: false,
                    layout: [
                        '_1_2_3_+@X',
                        '_4_5_6_-@U',
                        '_7_8_9_*@E',
                        '_0_._=_/']
                });
                $('div.dx-numberbox input.dx-texteditor-input[readonly],div.dx-textbox input.dx-texteditor-input').calculator({
                    showOn: 'operator',
                    isOperator: () => { return false; },
                    onButton: (label: any, value: any, inst: any) => {
                        if (label == "Use")
                            this.focusedObservable!(value);
                        if (label == "Close")
                            this.calculatorOpened(false);
                    },
                    constrainInput: false,
                    layout: [
                        '_1_2_3_+@X',
                        '_4_5_6_-',
                        '_7_8_9_*',
                        '_0_._=_/']
                });
                this.popupInputs[2].select();
                this.bindShortcut();
            }, 0);
        },
        onHiding: (e) => {
            this.unbindShortcut();
        }
    });
    
    

    numberBoxKeyDown = (e: any) => {
        if (e.event.key == '.') {
            let inputEl = e.element.getElementsByClassName('dx-texteditor-input')[0];
            if (inputEl.selectionStart == 0 && inputEl.selectionEnd == inputEl.value.length) {
                inputEl.value = Math.round((inputEl.value - Math.floor(inputEl.value)) * 100) / 100;
                inputEl.setSelectionRange(1, 1);
            }
        }
    };

    numberBoxFocusIn = (numberBox: any, x: any) => {
        this.focusedObservable = numberBox;
        setTimeout ( () => {
            x.element.children[1].children[0].children[0].select();
        }, 10);
    };

    selectBoxFocusIn = (x: any) => {
        setTimeout ( () => {
            x.element.children[0].children[1].children[0].children[0].select();
        }, 0);
    };
    
    form = {
        title: {
            value: this.model.title
        },
        description: {
            value: this.model.description
        },
        pasteTitle: {
            value: this.model.pasteTitle,
            text: "Paste title"
        },
        quantity: <dxKnockoutNumberBoxOptions> {
            min:0,
            value: this.model.quantity,
            onKeyDown: this.numberBoxKeyDown,
            onFocusIn: (x: any) =>  this.numberBoxFocusIn(this.model.quantity, x)
         },
        unitOfMeasure: <DevExpress.ui.dxSelectBoxOptions>{
            acceptCustomValue: true,
            value: this.model.unitOfMeasure,
            dataSource: new DevExpress.data.ArrayStore({
                data: this.unitsOfMeasure
            }),
            onCustomItemCreating: (data) => {
                if (!data.text) {
                    data.customItem = null;
                    return;
                }

                let dataSource = data.component!.getDataSource();
                dataSource.store().insert(data.text).then(() => dataSource.load()).then(() => {
                    data.customItem = data.text;
                });
            },
            onFocusIn: (x: any) =>  this.selectBoxFocusIn(x)
        },
        craftCode: <DevExpress.ui.dxSelectBoxOptions>{
            acceptCustomValue: true,
            searchEnabled: true,
            searchExpr: "code",
            value: this.model.craftCode,
            displayExpr: "code",
            itemTemplate: "crewItemTemplate",
            valueExpr: "code",
            dataSource: new DevExpress.data.ArrayStore({
                data:[ ],
                key: "code"
            }),
            onSelectionChanged: (e: any) => {
                let estimate = this.params.app.state.estimate();
                let wageOverriddenInEstimate = false;
                
                if (e.selectedItem && !this.craftFirstTimeSelected()) {
                    let estimateRows = estimate!.rows();
                    let estimateRowWithSameCraftCode = _.find(estimateRows, (c: any) => 
                        c.attributes.craftCode == e.selectedItem.code);
                    if (estimateRowWithSameCraftCode && estimateRowWithSameCraftCode.attributes.hourlyWage != 0) {
                        wageOverriddenInEstimate = estimateRowWithSameCraftCode.attributes.hourlyWage != e.selectedItem.hourlyWadgeRaw;
                        this.model.hourlyWage(estimateRowWithSameCraftCode.attributes.hourlyWage);
                    }
                }

                if (!wageOverriddenInEstimate)
                {
                    if (estimate!.laborAreaModApplied()) {
                        if (e.selectedItem && e.selectedItem.hourlyWadge && !this.craftFirstTimeSelected())
                            this.model.hourlyWage(e.selectedItem.hourlyWadge);
                    }  else {
                        if (e.selectedItem && e.selectedItem.hourlyWadgeRaw && !this.craftFirstTimeSelected())
                            this.model.hourlyWage(e.selectedItem.hourlyWadgeRaw);
                    }
                }
                
                this.model.laborPriceOverride(wageOverriddenInEstimate || estimate!.laborAreaModApplied());
                
                if (e.selectedItem && e.selectedItem.hourlyWadgeRaw)
                    this.model.hourlyWageRaw(e.selectedItem.hourlyWadgeRaw);
                
                if (e.selectedItem)
                    this.model.crewDescription(e.selectedItem.description);

                this.craftFirstTimeSelected(false);

                console.log("estomate-cost-row-popup, crews, selection changed", e.selectedItem);
            },
            onCustomItemCreating: (data) => {
                if (!data.text) {
                    data.customItem = null;
                    return;
                }

                data.text = data.text.toUpperCase();
                let dataSource = data.component!.getDataSource();
                dataSource.store().byKey(data.text)
                    .done(function (existingItem:any) {
                    data.customItem = existingItem;
                    return;
                    })
                    .fail(function () {
                        let newItem = {
                            code: data.text,
                            description: null,
                            hourlyWadge: 0,
                            hourlyWadgeRaw: 0
                        };

                        data.customItem = dataSource.store().insert(newItem)
                            .then(() => dataSource.load())
                            .then(() => {
                                return newItem;
                            })
                            .catch((error:any) => {
                                throw error;
                            });
                    });
            }
        },
        hourlyWage: {
            format: "#,##0.00",
            min:0,
            value: this.model.hourlyWage,
            onKeyDown: this.numberBoxKeyDown,
            onFocusIn: (x: any) =>  this.numberBoxFocusIn(this.model.hourlyWage, x)
        },
        hourlyWageRaw: {
            format: "#,##0.00",
            min: 0,
            value: this.model.hourlyWageRaw,
            onKeyDown: this.numberBoxKeyDown,
            visible: this.model.laborPriceOverride,
            readOnly: true
        },
        manHours: {
            format: "#,##0.000",
            min:0,
            value: this.model.manHours,
            onKeyDown: this.numberBoxKeyDown,
            onFocusIn: (x: any) =>  this.numberBoxFocusIn(this.model.manHours, x)
        },
        manHoursTotal: {
            tabIndex: -1,
            format: "#,##0.000",
            value: this.computed.manHoursTotal,
            readOnly: true
        },
        material: {
            format: "#,##0.00",
            min: 0,
            value: this.model.material,
            onKeyDown: this.numberBoxKeyDown,
            onFocusIn: (x: any) =>  this.numberBoxFocusIn(this.model.material, x)
        },
        materialTotal: {
            tabIndex: -1,
            format: "#,##0.00",
            value: this.computed.materialTotal,
            readOnly: true
        },
        labor: {
            format: "#,##0.00",
            min:0,
            value: this.model.labor,
            onKeyDown: this.numberBoxKeyDown,
            onFocusIn: (x: any) =>  this.numberBoxFocusIn(this.model.labor, x)
        },
        laborTotal: {
            tabIndex: -1,
            format: "#,##0.00",
            value: this.computed.laborTotal,
            readOnly: true
        },
        equipment: {
            format: "#,##0.00",
            min:0,
            value: this.model.equipment,
            onKeyDown: this.numberBoxKeyDown,
            onFocusIn: (x: any) =>  this.numberBoxFocusIn(this.model.equipment, x)
        },
        equipmentTotal: {
            tabIndex: -1,
            format: "#,##0.00",
            value: this.computed.equipmentTotal,
            readOnly: true
        },
        total: {
            format: "#,##0.00",
            min:0,
            value: this.model.total,
            readOnly: this.computed.isTotalReadonly,
            onFocusIn: (x: any) =>  this.numberBoxFocusIn(this.model.total, x)
        },
        totalTotal: {
            tabIndex: -1,
            format: "#,##0.00",
            value: this.computed.totalTotal,
            readOnly: true
        }
    };

    helpTitle = {
        target: "#helpTitle",
        showEvent: "dxclick",
        hideEvent: "dxhoverend",
        position: "bottom",
        showTitle: true,
        width: 320,
        title: "Title",
        visible: false,
        animation: {
            show: {
                type: "pop",
                from: {  scale: 0 },
                to: { scale: 1 }
            },
            hide: {
                type: "fade",
                from: 1,
                to: 0
            }
        }
    };

    helpDescription = {
        target: "#helpDescription",
        showEvent: "dxclick",
        hideEvent: "dxhoverend",
        position: "bottom",
        showTitle: true,
        width: 320,
        title: "Description",
        visible: false,
        animation: {
            show: {
                type: "pop",
                from: {  scale: 0 },
                to: { scale: 1 }
            },
            hide: {
                type: "fade",
                from: 1,
                to: 0
            }
        }
    };

    helpQuantity = {
        target: "#helpQuantity",
        showEvent: "dxclick",
        hideEvent: "dxhoverend",
        position: "bottom",
        showTitle: true,
        width: 320,
        title: "Quantity",
        visible: false,
        animation: {
            show: {
                type: "pop",
                from: {  scale: 0 },
                to: { scale: 1 }
            },
            hide: {
                type: "fade",
                from: 1,
                to: 0
            }
        }
    };

    helpPasteTitle = {
        target: "#helpPasteTitle",
        showEvent: "dxclick",
        hideEvent: "dxhoverend",
        position: "bottom",
        showTitle: true,
        width: 320,
        title: "Paste Title",
        visible: false,
        animation: {
            show: {
                type: "pop",
                from: {  scale: 0 },
                to: { scale: 1 }
            },
            hide: {
                type: "fade",
                from: 1,
                to: 0
            }
        }
    };

    helpMeasurement = {
        target: "#helpMeasurement",
        showEvent: "dxclick",
        hideEvent: "dxhoverend",
        position: "bottom",
        showTitle: true,
        width: 320,
        title: "Measurement",
        visible: false,
        animation: {
            show: {
                type: "pop",
                from: {  scale: 0 },
                to: { scale: 1 }
            },
            hide: {
                type: "fade",
                from: 1,
                to: 0
            }
        }
    };

    helpCraftCode = {
        target: "#helpCraftCode",
        showEvent: "dxclick",
        hideEvent: "dxhoverend",
        position: "bottom",
        showTitle: true,
        width: 320,
        title: "Craft Code",
        visible: false,
        animation: {
            show: {
                type: "pop",
                from: {  scale: 0 },
                to: { scale: 1 }
            },
            hide: {
                type: "fade",
                from: 1,
                to: 0
            }
        }
    };

    helpHourlyWage = {
        target: "#helpHourlyWage",
        showEvent: "dxclick",
        hideEvent: "dxhoverend",
        position: "bottom",
        showTitle: true,
        width: 400,
        title: "Hourly Wage",
        visible: false,
        animation: {
            show: {
                type: "pop",
                from: {  scale: 0 },
                to: { scale: 1 }
            },
            hide: {
                type: "fade",
                from: 1,
                to: 0
            }
        }
    };

    helpHourlyWageRaw = {
        target: "#helpHourlyWageRaw",
        showEvent: "dxclick",
        hideEvent: "dxhoverend",
        position: "bottom",
        showTitle: true,
        width: 400,
        title: "Costbook Wage",
        visible: false,
        animation: {
            show: {
                type: "pop",
                from: {  scale: 0 },
                to: { scale: 1 }
            },
            hide: {
                type: "fade",
                from: 1,
                to: 0
            }
        }
    };

    helpManHours = {
        target: "#helpManHours",
        showEvent: "dxclick",
        hideEvent: "dxhoverend",
        position: "bottom",
        showTitle: true,
        width: 450,
        title: "Man-Hours",
        visible: false,
        animation: {
            show: {
                type: "pop",
                from: {  scale: 0 },
                to: { scale: 1 }
            },
            hide: {
                type: "fade",
                from: 1,
                to: 0
            }
        }
    };

    helpMaterial = {
        target: "#helpMaterial",
        showEvent: "dxclick",
        hideEvent: "dxhoverend",
        position: "bottom",
        showTitle: true,
        width: 320,
        title: "Material",
        visible: false,
        animation: {
            show: {
                type: "pop",
                from: {  scale: 0 },
                to: { scale: 1 }
            },
            hide: {
                type: "fade",
                from: 1,
                to: 0
            }
        }
    };

    helpLabor = {
        target: "#helpLabor",
        showEvent: "dxclick",
        hideEvent: "dxhoverend",
        position: "bottom",
        showTitle: true,
        width: 320,
        title: "Labor",
        visible: false,
        animation: {
            show: {
                type: "pop",
                from: {  scale: 0 },
                to: { scale: 1 }
            },
            hide: {
                type: "fade",
                from: 1,
                to: 0
            }
        }
    };

    helpEquipment = {
        target: "#helpEquipment",
        showEvent: "dxclick",
        hideEvent: "dxhoverend",
        position: "bottom",
        showTitle: true,
        width: 320,
        title: "Equipment",
        visible: false,
        animation: {
            show: {
                type: "pop",
                from: {  scale: 0 },
                to: { scale: 1 }
            },
            hide: {
                type: "fade",
                from: 1,
                to: 0
            }
        }
    };

    helpTotal = {
        target: "#helpTotal",
        showEvent: "dxclick",
        hideEvent: "dxhoverend",
        position: "bottom",
        showTitle: true,
        width: 400,
        title: "Total",
        visible: false,
        animation: {
            show: {
                type: "pop",
                from: {  scale: 0 },
                to: { scale: 1 }
            },
            hide: {
                type: "fade",
                from: 1,
                to: 0
            }
        }
    };

    constructor(private params: PopupParamsWithPlayload<EstimateCostRowPopupParams>) {
        this.params.visible.subscribe(x => this.init(x));
    }

    async init(visible: boolean) {
        if (!visible) {
            this.isSaving = false;
            return;
        }
        this.reset();

        let estimate = this.params.app.state.estimate();

        if (!estimate)
            return;

        let self = this;

        let craftCodes = estimate.craftCodes();
        estimate.rows().forEach((x) => {
            if (x.type != 1)
                return;
            let craftCode = x.attributes["craftCode"];
            if (!craftCode)
                return;
            let rate = x.attributes["hourlyWage"];
            if (!_.find(craftCodes,(c:any) => c.code == craftCode)) {
                let newCode : CraftCode = { code: craftCode, description: "", 
                    hourlyWadge: rate, hourlyWadgeRaw: rate };
                craftCodes.push(newCode);
            }
        });
        craftCodes = _.orderBy(craftCodes, ['code']);

        craftCodes!.forEach((x) => {
            (<DevExpress.data.ArrayStore>self.form.craftCode.dataSource!).insert(x);
        });

        this.model.laborPriceOverride(estimate.laborAreaModApplied());

        this.craftFirstTimeSelected(true);

        let lastSelectedRow: EstimateRow | null = null;
        if (estimate.baseRow())
            lastSelectedRow = estimate.baseRow();
        if (estimate.selectedRow().length > 0) {
            lastSelectedRow = estimate.selectedRow()[0];
        }
        if(this.params.data!.insertToTheEnd) {
            lastSelectedRow = null;
        }

        console.log('init edit', this.params.data!.popupMode, lastSelectedRow, estimate.selectedRow(), estimate.baseRow());

        this.computed.notifyEnabled = false;

        let unitsDataSource = <DevExpress.data.ArrayStore>this.form.unitOfMeasure.dataSource;

        switch (this.params.data!.popupMode) {
            case PopupMode.New:

                this.model.id(undefined);

                if(this.params.data!.insertAbove) {
                    this.model.baseRowId(-1);
                }
                else if(lastSelectedRow)
                    this.model.baseRowId(lastSelectedRow.id);


                this.model.title("");
                this.model.pasteTitle(true);
                this.model.description("");
                this.model.unitOfMeasure("");
                this.model.craftCode("");
                this.model.quantity(0);
                this.model.hourlyWage(0);
                this.model.hourlyWageRaw(0);
                this.model.manHours(0);
                this.model.material(0);
                this.model.labor(0);
                this.model.equipment(0);
                this.model.total(0);
                this.model.crewDescription("");
                this.craftFirstTimeSelected(false);

                break;

            case PopupMode.NewFromCostRow:
                let costbook = this.params.app.state.costbook();

                if (!costbook)
                    return;

                let buffer = this.params.app.state.buffer();

                if(buffer.length == 0)
                    return;

                let bufferItem = _.first(buffer);

                if(!bufferItem)
                    return;

                let costbookRow = <CostbookRow>bufferItem.data;

                if (!costbookRow)
                    return;

                this.craftFirstTimeSelected(false);

                this.model.id(undefined);

                this.model.baseRowId(lastSelectedRow ? lastSelectedRow.id : undefined);

                this.model.pasteTitle(true);

                if (costbookRow.attributes.unitOfMeasure) {
                    unitsDataSource.byKey(costbookRow.attributes.unitOfMeasure)
                        .fail(function () {
                            unitsDataSource!.insert(costbookRow.attributes.unitOfMeasure).then(() => unitsDataSource!.load());
                        });
                }

                switch (costbookRow.type) {
                    case CostbookRowType.aggregateCost:
                    case CostbookRowType.aggregateCostMLET:
                        let materialPrice = costbookRow.attributes.materialPrice ? costbookRow.attributes.materialPrice : 0;
                        let materialPriceRaw = costbookRow.attributes.materialPriceRaw ? costbookRow.attributes.materialPriceRaw : 0;

                        this.model.craftCode(costbookRow.attributes.crew);
                        let hourlyWage: number = costbookRow.attributes.hourlyWage ? costbookRow.attributes.hourlyWage : 0;
                        let hourlyWageRaw: number = costbookRow.attributes.hourlyWageRaw ? costbookRow.attributes.hourlyWageRaw : 0;

                        this.model.manHours(costbookRow.attributes.hours ? costbookRow.attributes.hours : 0);
                        
                        let rateOverridden = false;
                        let estimateRows = estimate!.rows();
                        let estimateRowWithSameCraftCode = _.find(estimateRows, (c: any) =>
                            c.attributes.craftCode == costbookRow.attributes.crew);
                        if (costbookRow.attributes.crew && estimateRowWithSameCraftCode && 
                            estimateRowWithSameCraftCode.attributes.hourlyWage != 0) {
                            this.model.hourlyWage(estimateRowWithSameCraftCode.attributes.hourlyWage);
                            rateOverridden = true;
                        } else {
                            this.model.hourlyWage(estimate.laborAreaModApplied() ? hourlyWage : hourlyWageRaw);
                        }
                        this.model.hourlyWageRaw(hourlyWageRaw);
                        
                        this.model.quantity(1);
                        this.model.title(costbookRow.attributes.title);
                        this.model.description(costbookRow.attributes.pasteName || costbookRow.attributes.name);
                        this.model.unitOfMeasure(costbookRow.attributes.unitOfMeasure);
                        
                        this.model.material(estimate.materialAreaModApplied() ? materialPrice : materialPriceRaw);
                        this.model.equipment(costbookRow.attributes.equipmentPrice ? costbookRow.attributes.equipmentPrice : 0);

                        if (!rateOverridden) {
                            if (costbookRow.attributes.totalPrice && (estimate.materialAreaModApplied() || estimate.equipmentAreaModApplied() || estimate.laborAreaModApplied())) {
                                this.model.total(costbookRow.attributes.totalPrice);
                            } else {
                                if (costbookRow.attributes.totalPriceRaw)
                                    this.model.total(costbookRow.attributes.totalPriceRaw);
                            }
                        }

                        break;
                    case CostbookRowType.materialCost:
                        this.model.quantity(1);
                        this.model.title(costbookRow.attributes.title);
                        this.model.description(`${costbookRow.attributes.name} ${this.params.data!.period}`);
                        this.model.unitOfMeasure(costbookRow.attributes.unitOfMeasure);
                        this.model.material(this.params.data!.price!); //override or not feature was applied on cost-picker
                        this.model.total(this.params.data!.price!);

                        break;
                    case CostbookRowType.purchaseCost:
                    case CostbookRowType.equipmentCost:
                        this.model.title(costbookRow.attributes.title);
                        this.model.description(`${costbookRow.attributes.equipment} ${this.params.data!.period}`);

                        this.model.unitOfMeasure('Ea');
                        this.model.quantity(1);
                        this.model.equipment(this.params.data!.price!);
                        this.model.total(this.params.data!.price!);

                        break;
                    case CostbookRowType.section:
                        break;
                    case CostbookRowType.unknown:
                        break;
                    case CostbookRowType.customCost:
                        this.model.quantity(1);
                        this.model.title(costbookRow.attributes.title);
                        this.model.description(`${costbookRow.attributes.name} ${this.params.data!.period}`);
                        this.model.unitOfMeasure(costbookRow.attributes.unitOfMeasure);
                        this.model.total(this.params.data!.price!);

                        break;
                }


                break;

            case PopupMode.Edit:

                if(!lastSelectedRow)
                    return;

                unitsDataSource.byKey(lastSelectedRow.attributes.unitOfMeasure)
                    .fail(function () {
                        unitsDataSource!.insert(lastSelectedRow!.attributes.unitOfMeasure).then(() => unitsDataSource!.load());
                    });

                this.model.id(lastSelectedRow.id);
                this.model.baseRowId(undefined);

                this.model.title("");
                this.model.pasteTitle(true);
                this.model.description("");
                this.model.hourlyWage(lastSelectedRow.attributes.hourlyWage);
                this.model.unitOfMeasure(lastSelectedRow.attributes.unitOfMeasure);
                this.model.craftCode(lastSelectedRow.attributes.craftCode);
                let quantity = lastSelectedRow.attributes.quantity;
                if (quantity - Math.floor(quantity) == 0)
                    quantity = Math.floor(quantity);
                this.model.quantity(quantity);
                this.model.manHours(lastSelectedRow.attributes.manHours);
                this.model.material(lastSelectedRow.attributes.material);
                this.model.labor(lastSelectedRow.attributes.labor);
                this.model.equipment(lastSelectedRow.attributes.equipment);
                if (this.computed.isTotalReadonly()) {
                    this.model.total(this.computed.getTotal());
                }
                else {
                    this.model.total(lastSelectedRow.attributes.total);
                }

                break;
        }

        this.computed.notifyEnabled = true;

        this.mode(this.params.data!.editorMode);

        switch (this.mode()) {
            case EditorMode.Advanced:
                this.popup.setHeight(600);
                break;
            case EditorMode.Simple:
                this.popup.setHeight(560);
                break;
        }
    }

    reset() {
        this.model.title("");
        this.model.description("");
        this.model.pasteTitle(true);
        this.model.unitOfMeasure("");
        this.model.craftCode("");
        this.model.quantity(0);
        this.model.hourlyWage(0);
        this.model.hourlyWageRaw(0);
        this.model.manHours(0);
        this.model.material(0);
        this.model.labor(0);
        this.model.equipment(0);
        this.model.total(0);
        this.model.crewDescription("");
    }

    save() {
        if(!this.isSaving){
            this.isSaving = true;
            
            return this.params.app.apiManager.estimateRows.saveCostRow({
                estimateId: this.params.app.state.estimate()!.id(),
                id: this.model.id(),
                baseRowId: this.model.baseRowId(),

                title: this.model.title(),
                pasteTitle: this.model.pasteTitle(),
                description: this.model.description(),

                quantity: this.model.quantity(),
                unitOfMeasure: this.model.unitOfMeasure(),
                craftCode: this.model.craftCode(),
                hourlyWage: this.model.hourlyWage(),
                manHours: this.model.manHours(),
                material: this.model.material(),
                labor: this.model.labor(),
                equipment: this.model.equipment(),
                total: this.model.total()
            }).then((data) => {
                this.params.data!.result = data;

                this.params.app.state.canUndo(data!.history.canUndo);
                this.params.app.state.canRedo(data!.history.canRedo);

                this.params.app.state.estimate()!.pendingSelectedRowId(data!.id);

                this.params.app.state.estimate()!.timestamp(new Date());
                this.params.reject = false;
                this.params.visible(false);
            }) 
        }
    }

    close() {
        this.params.reject = true;
        this.params.visible(false);
    }

    unbindShortcut(){
        _.forEach(this.popupInputs, (target) => this.params.app.shortcutsManager.unbindElement(target));
    };

    bindShortcut(){
        let commandType = this.params.data!.popupMode == PopupMode.New ? CommandType.CreateEstimateCostRow : CommandType.EditEstimateRow;
        
        _.forEach(this.popupInputs, (target) => {
            let shortcutCommand = this.params.app.shortcutsManager.getShotcutByCommands([commandType]);
            this.params.app.shortcutsManager.bindCommand(target, shortcutCommand[0].shortcut, commandType);
        });
    };
}

export default {
    viewModel: EstimateCostRowPopupViewModel,
    template: require('./estimate-cost-row-popup.html')
};


// WEBPACK FOOTER //
// ./ClientApp/components/estimate-cost-row-popup/estimate-cost-row-popup.ts